import { render, staticRenderFns } from "./Powerpoint.vue?vue&type=template&id=28b2148e&scoped=true&"
import script from "./Powerpoint.vue?vue&type=script&lang=js&"
export * from "./Powerpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2148e",
  null
  
)

export default component.exports